import { WorkflowState } from '@/types/workflows'
import { KeyboardShortcutGroup } from '@/components/keyboard-shortcuts-popover/KeyboardShortcutsDialog'
import { altHotKeyStr, metaHotKeyStr, modHotKeyStr } from './os'

export function getShortcuts(
  documentView?:
    | WorkflowState['default_document_view']
    | 'lite-idle'
    | 'lite-processing',
) {
  if (documentView === 'lite-processing') {
    return []
  }

  const documentShortcuts: [string, string][] = [
    ['Close Document', 'Esc'],
    ['Previous Document', `${altHotKeyStr} + 1`],
    ['Next Document', `${altHotKeyStr} + 2`],
    ['Previous Page', `${altHotKeyStr} + 3 / ${metaHotKeyStr} + Scroll Up`],
    ['Next Page', `${altHotKeyStr} + 4 / ${metaHotKeyStr} + Scroll Down`],
  ]

  if (documentView !== 'lite-idle') {
    documentShortcuts.push(
      ['Primary Action', `${altHotKeyStr} + D`],
      ['Stay on Document on Event', 'Hold Shift'],
      ['Hold to Hide Chips', `${altHotKeyStr} + V`],
    )

    if (documentView === 'validation') {
      documentShortcuts.push(
        ['Toggle Layout', `${altHotKeyStr} + O`],
        ['Field Quick Select', `${altHotKeyStr} + Click`],
      )
    }
  }

  const shortcuts: KeyboardShortcutGroup[] = [
    {
      title: 'Document Shortcuts',
      shortcuts: documentShortcuts.reduce(
        (acc, [title, shortcut]) => ({ ...acc, [title]: shortcut }),
        {},
      ),
    },
  ]

  if (documentView === 'validation') {
    shortcuts.push({
      title: 'Field Shortcuts',
      shortcuts: {
        'Clear Selected Field Chips': `${modHotKeyStr} + Del`,
        'Cycle Through Favorite Fields': `Ctrl + ${metaHotKeyStr} + Tab`,
        'Multi-Select': 'Shift + Click and Drag',
        'Multi-Deselect': `Shift + ${altHotKeyStr} + Click and Drag`,
      },
    })
  }

  if (documentView === 'validation' || documentView === 'lite-idle') {
    const tableShortcuts: Record<string, string> = {
      'Insert Row Above': `${modHotKeyStr} + ${altHotKeyStr} + Shift + Up`,
      'Insert Row Below': `${modHotKeyStr} + ${altHotKeyStr} + Shift + Down`,
      'Delete Row': `${modHotKeyStr} + ${altHotKeyStr} + Shift + Del`,
    }

    if (documentView === 'validation') {
      tableShortcuts[
        'Row Multi-Select'
      ] = `${metaHotKeyStr} + ${altHotKeyStr} + Click and Drag`
      tableShortcuts[
        'Smart Row Select'
      ] = `${metaHotKeyStr} + ${altHotKeyStr} + Shift + Click and Drag`
    }
    shortcuts.push({
      title: 'Table Shortcuts',
      shortcuts: tableShortcuts,
    })
  }
  return shortcuts
}
